import { render, staticRenderFns } from "./ClassificationCell.vue?vue&type=template&id=f8485616&scoped=true&"
import script from "./ClassificationCell.vue?vue&type=script&lang=js&"
export * from "./ClassificationCell.vue?vue&type=script&lang=js&"
import style0 from "./ClassificationCell.vue?vue&type=style&index=0&id=f8485616&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8485616",
  null
  
)

export default component.exports